import type React from 'react';
import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { TabController } from './TabController';

/**
 * useTab — упрощённый хук для работы с текущей вкладкой (по pathname).
 * Возвращает действия для изменения заголовка и бейджа вкладки.
 *
 * Пример:
 *   const { setTabTitle, setTabBadge } = useTab();
 *   setTabTitle('Мои задачи');
 *   setTabBadge(<Badge size="xs">3</Badge>);
 */
export function useTab() {
  const { pathname, search } = useLocation();
  const ctrl = TabController.getInstance();

  const setTabTitle = useCallback(
    (title: string) => {
      if (!pathname || pathname === '/') return;
      // гарантируем наличие вкладки (если синхронизация ещё не успела)
      ctrl.addTab({ key: pathname, url: pathname + search, title, lastOpenedAt: Date.now() });
      ctrl.setTitle(pathname, title);
    },
    [ctrl, pathname, search]
  );

  const setTabBadge = useCallback(
    (badge: React.ReactNode) => {
      if (!pathname || pathname === '/') return;
      ctrl.setBadge(pathname, badge);
    },
    [ctrl, pathname]
  );

  return { setTabTitle, setTabBadge };
}
